export const getCitiesQueryKey = () => ["cities"];

export const getCityQueryKey = (id: number) => ["city", id];

export interface CityPoi {
    id?: number;
    name: string;
    address: string;
    address_lat: number;
    address_lng: number;
    image: File | string | null;
    video?: File | string | null;
    pdf?: File | string | null;
    activity_template_id: number | null;
    is_city_challenge: boolean;
    is_active: boolean;
}

export interface City {
    id: number;
    name: string;
    center_address: string;
    center_lat: number;
    center_lng: number;
    activities_target: number;
    pois: CityPoi[];
    is_active: boolean;
}
